import React from 'react';
import './footer.scss';

export default function Footer({ ...rest }) {
  return <footer className={'footer'} {...rest} />;
}
